/**
 * Hook for fetching and managing users.
 */

import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import type { User, UserConnection } from "@/types";

const GET_USERS = gql`
  query GetUsers($search: String, $limit: Int, $offset: Int) {
    users(search: $search, limit: $limit, offset: $offset) {
      items {
        id
        azureObjectId
        email
        firstName
        lastName
        isActive
        accessLevel
        createdAt
        lastLoginAt
        congridUserId
        sitedriveUserId
        substituteUserId
        substituteFirstName
        substituteLastName
      }
      totalCount
      hasNextPage
    }
  }
`;

interface UsersQueryResult {
  users: UserConnection;
}

export function useUsers(search?: string) {
  const { data, loading, error, refetch } = useQuery<UsersQueryResult>(
    GET_USERS,
    {
      variables: { search: search || undefined, limit: 100, offset: 0 },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    users: (data?.users.items || []) as User[],
    totalCount: data?.users.totalCount || 0,
    hasNextPage: data?.users.hasNextPage || false,
    loading,
    error,
    refetch,
  };
}
